var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMakiCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maki:cross"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33868 3.32935L11 8.99068L16.632 3.35868C16.7564 3.22627 16.9063 3.12034 17.0726 3.04725C17.239 2.97417 17.4183 2.93542 17.6 2.93335C17.989 2.93335 18.362 3.08787 18.6371 3.36293C18.9122 3.63798 19.0667 4.01103 19.0667 4.40002C19.0701 4.57983 19.0367 4.75845 18.9686 4.92491C18.9005 5.09137 18.7991 5.24215 18.6707 5.36802L12.9653 11L18.6707 16.7054C18.9124 16.9418 19.0542 17.2621 19.0667 17.6C19.0667 17.989 18.9122 18.3621 18.6371 18.6371C18.362 18.9122 17.989 19.0667 17.6 19.0667C17.4131 19.0744 17.2266 19.0432 17.0524 18.9751C16.8782 18.9069 16.72 18.8032 16.588 18.6707L11 13.0093L5.35334 18.656C5.22942 18.784 5.08137 18.8862 4.91775 18.9567C4.75412 19.0272 4.57816 19.0646 4.40001 19.0667C4.01103 19.0667 3.63797 18.9122 3.36292 18.6371C3.08787 18.3621 2.93334 17.989 2.93334 17.6C2.92992 17.4202 2.96329 17.2416 3.03138 17.0751C3.09948 16.9087 3.20087 16.7579 3.32934 16.632L9.03468 11L3.32934 5.29468C3.08762 5.0582 2.94587 4.73795 2.93334 4.40002C2.93334 4.01103 3.08787 3.63798 3.36292 3.36293C3.63797 3.08787 4.01103 2.93335 4.40001 2.93335C4.75201 2.93775 5.08934 3.08002 5.33868 3.32935Z",
    fill: "#2192FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakiCross);
export default __webpack_public_path__ + "static/media/maki_cross.274303aeb6a3143cf7c3bb23422282a2.svg";
export { ForwardRef as ReactComponent };